import React from 'react';
interface BankruptcyAssistanceProps {
    styles: React.CSSProperties;
}



const BankruptcyAssistance: React.FC<BankruptcyAssistanceProps> = ({ styles }) => {
    return (
        <div>
            <div className="leading-[37.5px] tracking-[-0.1px] mt-20 mb-10 text-[25px] max-sm:mt-[40px] max-sm:mb-[30px] max-sm:tracking-normal">
                Экономическая преступность — это сложная совокупность нескольких десятков составов преступлений,
                предусмотренных уголовным законом. Сложность данного рода преступлений связана, как с расследованием,
                так и с защитой законных прав и интересов.
            </div>
            <div className="flex flex-col gap-5 mt-5 max-sm:gap-[25px]">
                <p className="leading-[27.2px] max-sm:text-[15px]">
                    Согласно данным официальной статистики экономические преступления в современной России занимают
                    второе место по распространенности, несмотря на высокий уровень латентности данных преступлений.
                </p>
                <p className="leading-[27.2px] max-sm:text-[15px]">
                    Уголовные дела экономической направленности сопряжены с большим количеством следственных действий,
                    в том числе с сложными комплексными экспертизами. Помимо прочего,
                    данные категории дел связаны с большой гласностью и привлекают внимание общественности,
                    что может ухудшать положение лица и негативно сказаться на ход дела.
                </p>
                <p className="leading-[27.2px] max-sm:text-[15px]">
                    Общая теоретическая неподготовленность следственных органов приводит не только к затягиванию
                    необходимых процессов, но и к ошибкам со всеми вытекающими последствиями:
                    в виде избрания чрезмерно суровой меры пресечения, блокировке счетов, активов,
                    невозможности ведения любой финансово-хозяйственной деятельности предприятием
                    или ответственными лицами.
                </p>
                <p className="leading-[27.2px] max-sm:text-[15px]">
                    Но сложности нас не пугают, а вдохновляют!
                </p>
            </div>
            <div>
                <div className="flex flex-col gap-[30px] p-[28px] bg-[#F8F8F8] mt-10">
                    <div className="leading-[37.5px] tracking-[-0.1px] text-[25px] max-sm:tracking-normal">
                        Наша высококвалифицированная команда профессионалов предоставляет индивидуальное,
                        комплексное и всестороннее сопровождение  уголовных дел,
                        как на этапе проверки сообщения о преступлении, так и после возбуждения уголовного дела.
                    </div>
                    <div className="flex justify-between gap-[20px] mt-[28px] max-lg:flex-col max-lg:mt-0 max-lg:gap-[30px]">
                        <div className="gradient-border-left w-[412px] max-lg:w-full">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                При проведении предварительного&nbsp;<br className="max-lg:hidden"/>расследования
                            </p>
                        </div>
                        <div className="gradient-border-left w-[412px] max-lg:w-full">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Осуществления следственных действий,&nbsp;<br className="max-lg:hidden"/>проверок уполномоченными органами&nbsp;<br className="max-lg:hidden"/>и осуществлении
                                иных оперативно-розыскных мероприятий
                            </p>
                        </div>
                    </div>
                    <p className="leading-[27.2px] max-sm:text-[15px]">
                        Боле того, мы приложим все усилия, чтобы уголовное дело не было возбуждено,
                        а возбужденное подлежало прекращению. На всех стадиях судебного процесса, в т. ч.
                        при обжаловании приговора, снятии судимости, а также по вопросам изменения меры пресечения,
                        условно-досрочного освобождения или помилования.
                    </p>
                </div>
            </div>
            <div className="flex flex-col mt-10">
                <div className="leading-[30px] tracking-[-0.1px] text-[20px] max-sm:tracking-normal">
                    Наши специалисты отличаются своим подходом к информации: ее сбору, поиску, анализу&nbsp;<br className="max-md:hidden"/>и использованию.
                </div>
                <p className="leading-[27.2px] mt-[20px] max-sm:text-[15px]">
                    Высококвалифицированная команда готова немедленно приступить к изучению необходимого массива данных.
                   &nbsp;<br className="max-md:hidden"/>Мы не только занимаемся глубоким анализом уже известной информации,
                    но и получаем ее из дополнительных источников, проводим личные расследования,
                    инициируем переговоры и применяем альтернативные способы разрешения ситуации.
                </p>
                <div className="flex flex-col gap-[4px] mt-10">
                    <div className="flex flex-col gap-[20px] p-[28px] bg-[#F8F8F8]">
                        <div className="leading-[30px] tracking-[-0.1px] text-[20px] max-sm:tracking-normal">
                            Наше сопровождение уголовных дел безгранично&nbsp;<br className="max-md:hidden"/>
                            и не боится трудностей
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                При наличии отягчающих обстоятельств, в том числе связанных с деятельностью
                                преступных сообществ или группировок
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                В многоэпизодных делах экономической направленности, связанных иностранными гражданами,
                                предприятиями или транснациональной преступностью
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                В случае наличия нарушений со стороны уполномоченных лиц, служб и ведомств,
                                при проведении экспертиз, проверок или иных мероприятий
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[20px] p-[28px] bg-[#F8F8F8]">
                        <div className="leading-[30px] tracking-[-0.1px] text-[20px] max-sm:tracking-normal">
                            Специалисты компании не боятся разрешения резонансных&nbsp;<br className="max-md:hidden"/>
                            дел и событий с участием:
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Лиц, имеющих публичный статус
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Лиц, замещающих государственные должности
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Владельцев крупного бизнеса и капитала
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[20px] p-[28px] bg-[#F8F8F8]">
                        <div className="leading-[30px] tracking-[-0.1px] text-[20px] max-sm:tracking-normal">
                            Наша команда способна курировать вопросы пребывания&nbsp;<br className="max-md:hidden"/>
                            осужденных в исправительных учреждениях, а именно
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Соблюдение условий пребывания
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Гарантия отсутствия угрозы жизни и здоровью со стороны временного и постоянного контингента
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Составление всех необходимых документов, ходатайств и прошений
                            </p>
                        </div>
                        <div className="gradient-border-left">
                            <p className="leading-[27.2px] max-xl:mt-0 tracking-[0.1px] max-sm:text-[15px] pl-[15px]">
                                Доведения критически важной информации до администрации пенитенциарного учреждения
                               &nbsp;<br className="max-md:hidden"/>или законных представителей, лица, отбывающего наказание
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BankruptcyAssistance;